import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Stack,
  Divider,
} from "@mui/material";
import moment from 'moment';

import DefaultLogo from "../../components/layout/DefaultLogo";

import config from "../../config/config";
import "./OnboardFormPage.style.css";

const previewTemplate = [
  {
    backgroundColor: '#1d1b18',
    textColor: '#f5ece5',
    boldTextColor: '#f5ece5',
    textFontFamily: 'Inter, Helvetica, sans-serif',
    boldTextFontFamily: 'Arbutus Slab, Times',
  },
  {
    backgroundColor: '#003238',
    textColor: '#fff',
    boldTextColor: '#fce8ec',
    textFontFamily: 'Albert Sans, Helvetica, sans-serif',
    boldTextFontFamily: 'Oswald, Times',
  },
  {
    backgroundColor: '#ffffff',
    textColor: '#0a0a0a',
    boldTextColor: '#333',
    textFontFamily: 'Roboto Helvetica',
    boldTextFontFamily: 'Playfair Display, Times',
  },
];

const OnboardPreview = ({
  onboardTemplate,
  onboardCompanyLogo,
  onboardHeadingTitle,
  onboardHeadingMessage,
  onboardHeadingEnableDate,
  onboardSection1Enable,
  onboardSection1Image,
  onboardSection1ImageSelected,
  onboardSection1Heading,
  onboardSection1Content,
  onboardSection2Enable,
  onboardSection2Image,
  onboardSection2ImageSelected,
  onboardSection2Heading,
  onboardSection2Content,
  onboardSection3Enable,
  onboardSection3Image,
  onboardSection3ImageSelected,
  onboardSection3Heading,
  onboardSection3Content,
  onboardFooterHeading,
  onboardFooterContent,
}) => {
  return (
    <Grid
      item
      container
      display='flex'
      direction='row'
      justifyContent='center'
      columns={24}
    >
      <Container
        direction='column'
        sx={{ backgroundColor: previewTemplate[onboardTemplate].backgroundColor, width: '600px', paddingY: '20px', paddingX: '0px !important', borderRadius: '24px', fontFamily: previewTemplate[onboardTemplate].textFontFamily }}
      >
        <Stack alignItems="center" sx={{ mt: 4, mb: 2 }} spacing={2}>
          {onboardCompanyLogo !== 'uploads/user-logo.png' ?
            <Box
              component="img"
              src={`${config.SERVER_BASE_URL}/${onboardCompanyLogo}`}
              sx={{ width: '360px', alignSelf: 'center' }}
              alt="companyLogo"
            /> :
            <DefaultLogo mode={onboardTemplate < 2 ? 'light' : 'dark'} />
          }
          <Stack direction="column" alignItems="center" sx={{ marginX: '40px !important' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '2.5rem', color: previewTemplate[onboardTemplate].boldTextColor, textAlign: 'center', fontFamily: previewTemplate[onboardTemplate].boldTextFontFamily }}>{onboardHeadingTitle}</Typography>
            <Typography sx={{ fontSize: '0.9rem', mt: 0.5, color: previewTemplate[onboardTemplate].textColor, fontWeight: 300, textAlign: 'center', whiteSpace: 'pre-line' }}>
              {onboardHeadingMessage}
            </Typography>
            {onboardHeadingEnableDate &&
              <>
                <Typography sx={{ fontSize: '0.9rem', mt: 2, color: previewTemplate[onboardTemplate].textColor, fontWeight: 300, fontStyle: 'italic' }}>
                  <strong style={{ fontStyle: "normal" }}>Date:</strong> {`${moment().format('dddd, D')}th ${moment().format('MMMM YYYY')}`}
                </Typography>
                <Typography sx={{ fontSize: '0.9rem', color: previewTemplate[onboardTemplate].textColor, fontWeight: 300, fontStyle: 'italic' }}>
                  <strong style={{ fontStyle: "normal" }}>Time:</strong> {moment().format('h:mm a')}
                </Typography>
                <Typography sx={{ fontSize: '0.9rem', color: previewTemplate[onboardTemplate].textColor, fontWeight: 300, fontStyle: 'italic' }}>
                  <strong style={{ fontStyle: "normal" }}>Duration:</strong> 2 Hours
                </Typography>
              </>
            }
          </Stack>
        </Stack>
        {onboardSection1Enable &&
          <Stack alignItems="center" sx={{ mt: 5, mb: 3 }} spacing={2}>
            {onboardSection1ImageSelected ?
              <img src={onboardSection1ImageSelected} style={{ width: '100%' }} alt="section1_image" /> :
              <img src={`${config.SERVER_BASE_URL}/${onboardSection1Image}`} style={{ width: '100%' }} alt="section1_image" />
            }
            <Stack direction="column" alignItems="center"sx={{ marginX: '40px !important' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '1.9rem', color: previewTemplate[onboardTemplate].boldTextColor, textAlign: 'center', mt: 2, fontFamily: previewTemplate[onboardTemplate].boldTextFontFamily }}>{onboardSection1Heading}</Typography>
              <Typography sx={{ fontSize: '0.9rem', mt: 0.5, color: previewTemplate[onboardTemplate].textColor, fontWeight: 300, textAlign: 'center', whiteSpace: 'pre-line' }}>
                {onboardSection1Content}
              </Typography>
            </Stack>
          </Stack>
        }
        {onboardSection2Enable &&
          <Stack alignItems="center" sx={{ mt: 5, mb: 3 }} spacing={2}>
            {onboardSection2ImageSelected ?
              <img src={onboardSection2ImageSelected} style={{ width: '100%' }} alt="section2_image" /> :
              <img src={`${config.SERVER_BASE_URL}/${onboardSection2Image}`} style={{ width: '100%' }} alt="section2_image" />
            }
            <Stack direction="column" alignItems="center"sx={{ marginX: '40px !important' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '1.9rem', color: previewTemplate[onboardTemplate].boldTextColor, textAlign: 'center', mt: 2, fontFamily: previewTemplate[onboardTemplate].boldTextFontFamily }}>{onboardSection2Heading}</Typography>
              <Typography sx={{ fontSize: '0.9rem', mt: 0.5, color: previewTemplate[onboardTemplate].textColor, fontWeight: 300, textAlign: 'center', whiteSpace: 'pre-line' }}>
                {onboardSection2Content}
              </Typography>
            </Stack>
          </Stack>
        }
        {onboardSection3Enable &&
          <Stack alignItems="center" sx={{ mt: 5, mb: 3 }} spacing={2}>
            {onboardSection3ImageSelected ?
              <img src={onboardSection3ImageSelected} style={{ width: '100%' }} alt="section3_image" /> :
              <img src={`${config.SERVER_BASE_URL}/${onboardSection3Image}`} style={{ width: '100%' }} alt="section3_image" />
            }
            <Stack direction="column" alignItems="center"sx={{ marginX: '40px !important' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '1.9rem', color: previewTemplate[onboardTemplate].boldTextColor, textAlign: 'center', mt: 2, fontFamily: previewTemplate[onboardTemplate].boldTextFontFamily }}>{onboardSection3Heading}</Typography>
              <Typography sx={{ fontSize: '0.9rem', mt: 0.5, color: previewTemplate[onboardTemplate].textColor, fontWeight: 300, textAlign: 'center', whiteSpace: 'pre-line' }}>
                {onboardSection3Content}
              </Typography>
            </Stack>
          </Stack>
        }
        <Stack sx={{ mt: 5, mb: 3 }}>
          <Divider sx={{ mt: 2, mb: 2, borderColor: '#555', marginX: '80px !important' }} />
          <Stack direction="column" alignItems="center"sx={{ marginX: '40px !important' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '1rem', color: previewTemplate[onboardTemplate].boldTextColor, textAlign: 'center', mt: 2, fontFamily: previewTemplate[onboardTemplate].boldTextFontFamily }}>
              {onboardFooterHeading}
            </Typography>
            <Typography sx={{ fontSize: '0.8rem', mt: 2, color: previewTemplate[onboardTemplate].textColor, fontWeight: 500, textAlign: 'center', whiteSpace: 'pre-line' }}>
              {onboardFooterContent}
            </Typography>
            <Typography sx={{ fontSize: '0.8rem', mt: 5, color: '#a1a5b7', fontWeight: 500, textAlign: 'center' }}>
              © Powered by Clientl.
            </Typography>
          </Stack>
        </Stack>
      </Container>      
    </Grid>
  );
}

export default OnboardPreview;
